// @ts-nocheck

export const MpAnimationSkins = {
  default: 'default',
  BROWN_1: 'carte_belleville',
  BROWN_2: 'carte_lecourbe',
  LIGHT_BLUE_1: 'carte_vaugirard',
  LIGHT_BLUE_2: 'carte_courcelle',
  LIGHT_BLUE_3: 'carte_republique',
  PURPLE_1: 'carte_villette',
  PURPLE_2: 'carte_neuilly',
  PURPLE_3: 'carte_paradis',
  ORANGE_1: 'carte_mozart',
  ORANGE_2: 'carte_saint_michel',
  ORANGE_3: 'carte_pigalle',
  RED_1: 'carte_matignon',
  RED_2: 'carte_malesherbes',
  RED_3: 'carte_henry_martin',
  YELLOW_1: 'carte_saint_honore',
  YELLOW_2: 'carte_place_bourse',
  YELLOW_3: 'carte_lafayette',
  GREEN_1: 'carte_breteuil',
  GREEN_2: 'carte_fosh',
  GREEN_3: 'carte_capucine',
  DARK_BLUE_1: 'carte_champs_elysees',
  DARK_BLUE_2: 'carte_paix',
  ENERGY_1: 'carte_electricite',
  ENERGY_2: 'carte_eau',
  STATION_1: 'carte_gare_nord',
  STATION_2: 'carte_gare_lyon',
  STATION_3: 'carte_gare_montparnasse',
  STATION_4: 'carte_gare_lazare',
  COLLECTION_BROWN: 'collection_2 cartes_marron',
  COLLECTION_LIGHT_BLUE: 'collection_3_cartes_bleu_clair',
  COLLECTION_PURPLE: 'collection_3_cartes_violet',
  COLLECTION_ORANGE: 'collection_3_cartes_orange',
  COLLECTION_RED: 'collection_3_cartes_rouge',
  COLLECTION_YELLOW: 'collection_3_cartes_jaune',
  COLLECTION_GREEN: 'collection_3_cartes_vert',
  COLLECTION_DARK_BLUE: 'collection_2 cartes_bleu',
  COLLECTION_STATION: 'collection_4_cartes_gares',
  COLLECTION_ENERGY: 'collection_2 cartes_compagnies',
};

export const MpAnimationTypeCards = {
  WIN_CARD_SOLO: 'Win_carte_seule',
  WIN_FAMILY_2: 'Win_collection_2',
  WIN_FAMILY_3: 'Win_collection_3',
  WIN_FAMILY_4: 'Win_collection_4',
};
